import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import PropTypes from "prop-types";
import LayerItem from "./LayerItem";

const LayerList = ({
  layers,
  onToggleVisibility,
  onOpacityChange,
  onOpenInfo,
  onRemove,
  forestLossRange,
  updateYearRange,
  updateYearSelection,
  deforestationRange,
  updateDeforestationRange,
  selectedYear,
}) => {
  return (
    <Droppable droppableId="layers-droppable">
      {(provided) => (
        <div
          className="layer-list"
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {layers.map((layer, index) => (
            <Draggable key={layer.id} draggableId={layer.id} index={index}>
              {(provided, snapshot) => (
                <div
                  className={`draggable-layer ${
                    snapshot.isDragging ? "dragging" : ""
                  }`}
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                >
                  <LayerItem
                    layerId={layer.id}
                    layerName={layer.name}
                    layerDescription={layer.description}
                    loading={layer.loading}
                    isVisible={layer.isVisible}
                    onToggleVisibility={onToggleVisibility}
                    onOpenInfo={onOpenInfo}
                    opacity={layer.opacity}
                    onOpacityChange={(newOpacity) =>
                      onOpacityChange(layer.id, newOpacity)
                    }
                    onRemove={onRemove}
                    isForestLossRange={layer.id === "forest-loss-range"}
                    yearRange={layer.yearRange}
                    updateYearRange={updateYearRange}
                    updateYearSelection={
                      layer.id === "biomass-layer-id" ? updateYearSelection : null
                    }
                    deforestationRange={deforestationRange}
                    updateDeforestationRange={updateDeforestationRange}
                    isDragging={snapshot.isDragging}
                    dragHandleProps={provided.dragHandleProps}
                    {...(layer.id === "biomass-layer-id" && { selectedYear })}
                  />
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

LayerList.propTypes = {
  layers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      isVisible: PropTypes.bool.isRequired,
      opacity: PropTypes.number.isRequired,
      yearRange: PropTypes.shape({
        start: PropTypes.number,
        end: PropTypes.number,
      }),
      selectedYear: PropTypes.number,
    })
  ).isRequired,
  onToggleVisibility: PropTypes.func.isRequired,
  onOpacityChange: PropTypes.func.isRequired,
  onOpenInfo: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  forestLossRange: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
  }),
  updateYearRange: PropTypes.func,
  updateYearSelection: PropTypes.func,
  deforestationRange: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  updateDeforestationRange: PropTypes.func,
  selectedYear: PropTypes.number,
};

export default LayerList;
